/* ============================================================
   HAZAR v7 — سلوكيات خفيفة:
   ١) توجيه الدفع للنسخة العربية (?locale=ar-KW)
   ٢) ترجمة aria-labels المولّدة من الثيم إلى العربية
   ============================================================ */

/* ===== ١) الدفع بالعربي =====
   شوبيفاي يفتح صفحة الدفع افتراضياً بالإنجليزية (en-kw) رغم أن نسخة عربية
   RTL كاملة موجودة وجاهزة (تحقّقنا منها). الحل الآمن — بدون لمس إعدادات
   اللغة أو Translate & Adapt — هو تمرير locale=ar-KW على كل مداخل الدفع:
   روابط /checkout وأزرار name="checkout" (السلة والدرج الجانبي). */
(function(){
  "use strict";
  if (window.__hzArCheckoutInit) return;            /* idempotent */
  window.__hzArCheckoutInit = true;

  var LOCALE = "ar-KW";

  function arHref(h){
    try{
      var u = new URL(h, window.location.origin);
      /* /checkout أو /checkout/... فقط (وليس /checkouts/...) */
      if (!/^\/checkout(\/|$)/.test(u.pathname)) return h;
      u.searchParams.set("locale", LOCALE);
      return u.pathname + u.search + u.hash;
    }catch(e){ return h; }
  }

  function fixLinks(root){
    try{
      var scope = (root && root.querySelectorAll) ? root : document;
      var links = scope.querySelectorAll('a[href^="/checkout"]');
      for (var i = 0; i < links.length; i++){
        var h = links[i].getAttribute("href");
        if (h && h.indexOf("locale=") === -1){
          links[i].setAttribute("href", arHref(h));
        }
      }
    }catch(e){}
  }

  /* لو في صندوق موافقة على الشروط غير محدَّد — لا نتدخّل ونترك تنبيه الثيم يظهر */
  function termsBlocked(){
    try{
      var els = document.querySelectorAll('#hdt-agree, input[type="checkbox"][name*="agree" i]');
      for (var i = 0; i < els.length; i++){
        if (els[i].tagName === "INPUT" && els[i].type === "checkbox" && !els[i].checked) return true;
      }
      return false;
    }catch(e){ return false; }
  }

  function onClick(e){
    try{
      var t = e.target && e.target.closest
        ? e.target.closest('button[name="checkout"],input[name="checkout"]')
        : null;
      if (!t) return;
      if (termsBlocked()) return;
      e.preventDefault();
      window.location.href = "/checkout?locale=" + LOCALE;
    }catch(err){}
  }

  function start(){
    try{
      fixLinks(document);
      document.addEventListener("click", onClick, true);
      /* r59: التسجيل في المرسل الموحّد (theme.liquid) بدل مراقب خاص —
         13 مراقب subtree صاروا واحداً؛ الفولباك يبقى لو انجرفت الملفات */
      if (window.hzOnAdded){
        window.hzOnAdded(fixLinks);
      } else if ("MutationObserver" in window){
        new MutationObserver(function(muts){
          for (var i = 0; i < muts.length; i++){
            for (var j = 0; j < muts[i].addedNodes.length; j++){
              var nd = muts[i].addedNodes[j];
              if (nd.nodeType === 1) fixLinks(nd);
            }
          }
        }).observe(document.documentElement, { childList:true, subtree:true });
      }
    }catch(e){}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ===== ٢) aria-labels بالعربية (عناصر يولّدها الثيم بتسميات إنجليزية) ===== */
(function(){
  "use strict";
  if (window.__hzAriaArInit) return;                /* idempotent */
  window.__hzAriaArInit = true;

  var MAP = [
    ['[aria-label="push-menu"]', 'القائمة'],
    ['[aria-label="drawer-search"]', 'البحث'],
    ['a[aria-label="link"]', 'رابط تواصل'],
    ['[aria-label="previous"]', 'السابق'],
    ['[aria-label="next"]', 'التالي'],
    ['[aria-label="breadcrumbs"]', 'مسار التنقل']
  ];

  function apply(root){
    try{
      var scope = (root && root.querySelectorAll) ? root : document;
      for (var i = 0; i < MAP.length; i++){
        var els = scope.querySelectorAll(MAP[i][0]);
        for (var j = 0; j < els.length; j++) els[j].setAttribute("aria-label", MAP[i][1]);
      }
    }catch(e){}
  }

  function start(){
    apply(document);
    try{
      /* r59: المرسل الموحّد (childList فقط أصلاً — لا يلتقط تعديل aria-label) */
      if (window.hzOnAdded){
        window.hzOnAdded(apply);
      } else {
        new MutationObserver(function(muts){
          for (var i = 0; i < muts.length; i++){
            for (var j = 0; j < muts[i].addedNodes.length; j++){
              var nd = muts[i].addedNodes[j];
              if (nd.nodeType === 1) apply(nd);
            }
          }
        }).observe(document.documentElement, { childList:true, subtree:true });
      }
    }catch(e){}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ===== ٣) أسهم زجاجية بديلة لكاروسيلات المنتجات (v13) =====
   أزرار التنقّل الأصلية لا تقبل إعادة التنسيق (JS الثيم يفرض شكلها).
   ننشئ زرّين زجاجيين لكل كاروسيل منتجات فيه تنقّل أصلي، ونوكّل النقر
   للأزرار الأصلية (المخفيّة بالـ CSS عبر .hz-proxied) — بلا أي تدخّل
   في منطق التمرير نفسه. */
(function(){
  "use strict";
  if (window.__hzGlassNavInit) return;              /* idempotent */
  window.__hzGlassNavInit = true;

  var CHEV_LEFT  = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M14.5 5.5 8 12l6.5 6.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV_RIGHT = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9.5 5.5 16 12l-6.5 6.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function isRTL(){
    try{
      var d = document.documentElement;
      return (d.dir || getComputedStyle(d).direction) === "rtl";
    }catch(e){ return false; }
  }

  function buildBtn(cls, svg, label){
    var b = document.createElement("button");
    b.type = "button";
    b.className = "hz-nav " + cls;
    b.setAttribute("aria-label", label);
    b.innerHTML = svg;
    return b;
  }

  function enhance(slider){
    try{
      if (!slider || slider.__hzGlassNav) return;
      var nav  = slider.querySelector(".hdt-navigation");
      if (!nav) return;                              /* لا تنقّل أصلي — لا شيء نفعله */
      var prev = nav.querySelector(".hdt-slider__button--prev");
      var next = nav.querySelector(".hdt-slider__button--next");
      if (!prev || !next) return;
      slider.__hzGlassNav = true;

      /* «السابق» عند بداية السطر و«التالي» عند نهايته، والسهم يشير لجهة الحركة */
      var rtl   = isRTL();
      var pPrev = buildBtn("hz-nav-prev", rtl ? CHEV_RIGHT : CHEV_LEFT,  "السابق");
      var pNext = buildBtn("hz-nav-next", rtl ? CHEV_LEFT  : CHEV_RIGHT, "التالي");

      pPrev.addEventListener("click", function(){ try{ prev.click(); }catch(e){} });
      pNext.addEventListener("click", function(){ try{ next.click(); }catch(e){} });

      /* مرآة حالة التعطيل (بداية/نهاية الشريط) */
      function sync(){
        try{
          pPrev.disabled = !!prev.disabled;
          pNext.disabled = !!next.disabled;
        }catch(e){}
      }
      sync();
      try{
        new MutationObserver(sync).observe(nav, { attributes:true, subtree:true, attributeFilter:["disabled"] });
      }catch(e){}

      slider.appendChild(pPrev);
      slider.appendChild(pNext);
      slider.classList.add("hz-proxied");            /* الآن فقط يحقّ للـ CSS إخفاء الأصلية */
    }catch(e){}
  }

  function scan(root){
    try{
      var scope = (root && root.querySelectorAll) ? root : document;
      var sliders = scope.querySelectorAll("hdt-slider.hdt-slider__products.hdt-slider-has-nav");
      for (var i = 0; i < sliders.length; i++) enhance(sliders[i]);
      if (root && root.matches && root.matches("hdt-slider.hdt-slider__products.hdt-slider-has-nav")) enhance(root);
    }catch(e){}
  }

  function start(){
    scan(document);
    try{
      /* كواروسيلات تُحقن لاحقاً (درج السلة/البحث السريع…) — r59: المرسل الموحّد */
      if (window.hzOnAdded){
        window.hzOnAdded(scan);
      } else {
        new MutationObserver(function(muts){
          for (var i = 0; i < muts.length; i++){
            for (var j = 0; j < muts[i].addedNodes.length; j++){
              var nd = muts[i].addedNodes[j];
              if (nd.nodeType === 1) scan(nd);
            }
          }
        }).observe(document.documentElement, { childList:true, subtree:true });
      }
    }catch(e){}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ===== ٤) ملء الشاشة على الآيفون: viewport-fit=cover =====
   JS الثيم يعيد كتابة وسم viewport عند التحميل (يضيف maximum-scale ويمسح
   أي تعديل ثابت في theme.liquid). نعيد إلحاق viewport-fit=cover كلما
   تغيّر الوسم — حتى تمتد الصفحة خلف شريط iOS السفلي وتعمل
   env(safe-area-inset-*) في كبسولة الشريط السفلي. الدالة idempotent
   فلا تدور مع الـ MutationObserver. */
(function(){
  "use strict";
  if (window.__hzViewportFitInit) return;              /* idempotent */
  window.__hzViewportFitInit = true;

  /* r45: انعكس الاتجاه — التمديد تحت أشرطة سفاري (cover) كان يجعل سفاري
     يرسم «ستارة وهج بيضاء» خلف شريط عنوانه الموسّع عند التمرير لأعلى
     (شكوى سهيل). نضمن الآن إزالة viewport-fit=cover أينما ظهر — الصفحة
     تبقى داخل المنطقة الآمنة وسفاري يرسم زجاجه النظيف بلا وهج. */
  function fix(){
    try{
      var m = document.querySelector('meta[name="viewport"]');
      if (!m) return;
      var c = m.getAttribute("content") || "";
      if (c.indexOf("viewport-fit") !== -1){
        m.setAttribute("content", c.replace(/,?\s*viewport-fit=cover/g, ""));
      }
    }catch(e){}
  }

  function start(){
    fix();
    try{
      var m = document.querySelector('meta[name="viewport"]');
      if (m && "MutationObserver" in window){
        new MutationObserver(fix).observe(m, { attributes:true, attributeFilter:["content"] });
      }
    }catch(e){}
    /* شبكة أمان: بعض السكربتات تكتب الوسم متأخراً بعد التحميل */
    try{ setTimeout(fix, 1000); setTimeout(fix, 3000); }catch(e){}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ===== ٥) r41 — تعريب عناوين صفحات السياسات =====
   عنوان H1 في /policies/* تطبعه منصة شوبيفاي (ليس الثيم) بالإنجليزية دائماً؛
   نبدّله للعربي مع <title>. المتون تبقى ثنائية اللغة بقرار سهيل. */
(function(){
  "use strict";
  if (window.__hzPolicyArInit) return;               /* idempotent */
  window.__hzPolicyArInit = true;

  var MAP = {
    "refund-policy":      "سياسة الاستبدال والاسترجاع",
    "shipping-policy":    "سياسة الشحن والتوصيل",
    "terms-of-service":   "الشروط والأحكام",
    "privacy-policy":     "سياسة الخصوصية",
    "legal-notice":       "إشعار قانوني",
    "subscription-policy":"سياسة الاشتراك"
  };

  function start(){
    try{
      var m = location.pathname.match(/^\/policies\/([a-z-]+)/);
      if (!m || !MAP[m[1]]) return;
      var ar = MAP[m[1]];
      var h = document.querySelector(".shopify-policy__title h1") ||
              document.querySelector(".shopify-policy__title");
      if (h && !/[؀-ۿ]/.test(h.textContent || "")) h.textContent = ar;
      if (!/[؀-ۿ]/.test((document.title || "").split("–")[0])) document.title = ar + " – HAZAR";
      /* r46: متن السياسة يبدأ بنفس العنوان العربي — نخفي التكرار الأول فقط */
      var els = document.querySelectorAll(".shopify-policy__body .rte h2, .shopify-policy__body .rte h3, .shopify-policy__body .rte div, .shopify-policy__body .rte p strong");
      for (var i = 0; i < els.length; i++){
        if ((els[i].textContent || "").trim() === ar){ els[i].style.display = "none"; break; }
      }
    }catch(e){}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ===== ٦) r41 — وصولية: رابط صورة المنتج بصفحة السلة كان بلا اسم ===== */
(function(){
  "use strict";
  if (window.__hzCartImgAriaInit) return;            /* idempotent */
  window.__hzCartImgAriaInit = true;

  function fix(root){
    try{
      var scope = (root && root.querySelectorAll) ? root : document;
      var links = scope.querySelectorAll('a.hdt-page-cart__img:not([aria-label])');
      for (var i = 0; i < links.length; i++){
        var a = links[i];
        if ((a.textContent || "").trim()) continue;
        var row = a.closest("tr,li,[class*='item']");
        var t = row ? row.querySelector("a[href*='/products/']:not(.hdt-page-cart__img)") : null;
        a.setAttribute("aria-label", (t && t.textContent.trim()) ? t.textContent.trim() : "عرض المنتج");
      }
    }catch(e){}
  }
  function start(){
    fix(document);
    try{
      /* r59: المرسل الموحّد بدل مراقب خاص */
      if (window.hzOnAdded){
        window.hzOnAdded(fix);
      } else {
        new MutationObserver(function(muts){
          for (var i = 0; i < muts.length; i++)
            for (var j = 0; j < muts[i].addedNodes.length; j++){
              var nd = muts[i].addedNodes[j];
              if (nd.nodeType === 1) fix(nd);
            }
        }).observe(document.body || document.documentElement, { childList:true, subtree:true });
      }
    }catch(e){}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ===== ٧) r42 — theme-color ديناميكي لسفاري iOS =====
   سفاري يلوّن مناطقه الزجاجية (خلف شريط الحالة وخلف شريط العنوان) من
   theme-color — والوسم كان فارغاً فيسقط للأبيض ويضرب مع الشريط الغامق
   أعلى الصفحة ومع الفوتر الغامق أسفلها. نحدّث الوسم حسب موضع التمرير:
   غامق عند القمة (شريط الإعلان) وعند الفوتر، أبيض في باقي الصفحة. */
(function(){
  "use strict";
  if (window.__hzThemeColorInit) return;             /* idempotent */
  window.__hzThemeColorInit = true;

  var DARK = "#111111";
  var meta, ann, ticking = false, last = "";
  var footerVis = false, annH = 40;

  function pick(){
    if (footerVis) return DARK;
    if (ann && (window.scrollY || 0) < annH) return DARK;
    /* r45: وسط الصفحة — نُفرغ الوسم فيعود سفاري لتلوينه التكيفي */
    return "";
  }

  function apply(){
    ticking = false;
    try{
      var c = pick();
      if (c !== last){
        if (c) meta.setAttribute("content", c);
        else meta.removeAttribute("content");
        last = c;
      }
    }catch(e){}
  }

  function onScroll(){
    if (ticking) return;
    ticking = true;
    (window.requestAnimationFrame || setTimeout)(apply);
  }

  function measure(){
    annH = ann ? Math.max(40, ann.offsetHeight + 10) : 40;
  }

  function start(){
    try{
      /* r59: كروم ويندوز/لينكس يتجاهل theme-color في التبويبات العادية — صفر عمل هناك.
         نُبقي الميزة على iOS + iPadOS (يتنكّر كـ Macintosh) + سفاري ماك + أندرويد + PWA مثبّت. */
      var ua = navigator.userAgent || "";
      var wants = /iPhone|iPad|iPod|Android|Macintosh|Mac OS X/i.test(ua) ||
                  (window.matchMedia && matchMedia("(display-mode: standalone)").matches);
      if (!wants) return;

      meta = document.querySelector('meta[name="theme-color"]');
      if (!meta){
        meta = document.createElement("meta");
        meta.name = "theme-color";
        document.head.appendChild(meta);
      }
      ann    = document.querySelector(".hdt-section-announcement-bar");
      var footer = document.querySelector(".hz-footer") || document.querySelector("footer");
      measure();

      if (footer && "IntersectionObserver" in window){
        /* هامش سفلي -25% == الاختبار القديم fr.top < innerHeight*0.75 —
           صفر قراءات layout في مسار التمرير بعد الآن */
        new IntersectionObserver(function(es){
          footerVis = es[es.length - 1].isIntersecting;
          onScroll();
        }, { rootMargin: "0px 0px -25% 0px" }).observe(footer);
      }

      apply();
      window.addEventListener("scroll", onScroll, { passive:true });
      window.addEventListener("resize", function(){ measure(); onScroll(); }, { passive:true });
    }catch(e){}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ===== ٨) r55 — سطر الثقة تحت زر «أضيفي إلى السلة» (صفحة المنتج) ===== */
(function(){
  "use strict";
  if (window.__hzTrustInit) return;                  /* idempotent */
  window.__hzTrustInit = true;

  var HTML =
    '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 4v4h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>توصيل سريع لكل الكويت</span>' +
    '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>استبدال خلال ١٥ يوماً</span>';
    /* r56: حُذف «متوفر في ٩ فروع» بطلب سهيل — عنصران يكفيان */

  function inject(){
    try{
      if (!/^\/products\//.test(location.pathname)) return;
      if (document.querySelector(".hz-trustline")) return;
      /* فورم الشراء الرئيسي بالصفحة (وليس داخل المودالات) */
      var forms = document.querySelectorAll(".hdt-product-info__list form[action*='/cart/add'], form.hdt-main-product-form");
      for (var i = 0; i < forms.length; i++){
        var f = forms[i];
        if (f.closest("dialog")) continue;           /* لا نحقن داخل المودالات */
        var el = document.createElement("div");
        el.className = "hz-trustline";
        el.innerHTML = HTML;
        f.insertAdjacentElement("afterend", el);
        return;
      }
    }catch(e){}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", inject);
  else inject();
  try{ setTimeout(inject, 1500); }catch(e){}
})();

/* ===== ٩) r59 — لمعة الكومبوزيتور: حقن غلاف قصّ للمواقع الثلاثة =====
   القسم ٣٨ في hz-v7.css يرسم الشريط ويحرّكه بـ transform؛ نحن هنا فقط
   نحقن عنصر الغلاف .hz-sheen-clip داخل الهيدر والدروارات. */
(function(){
  "use strict";
  if (window.__hzSheenInit) return;                 /* idempotent */
  window.__hzSheenInit = true;

  var SEL = ".hdt-main-header, dialog.hdt-dialog-drawer, dialog#drawer-search-form";

  function add(host){
    try{
      /* فحص DOM حي (لا علامة expando): يصمد أمام innerHTML-wipe واستنساخ الهيدر */
      if (host.querySelector(":scope > .hz-sheen-clip")) return;
      var d = document.createElement("div");
      d.className = "hz-sheen-clip";
      d.setAttribute("aria-hidden", "true");
      host.appendChild(d);
    }catch(e){}
  }

  var queued = false;
  function scanAll(){
    queued = false;
    try{
      var hosts = document.querySelectorAll(SEL);
      for (var i = 0; i < hosts.length; i++) add(hosts[i]);
    }catch(e){}
  }

  function start(){
    scanAll();
    try{
      if (window.hzOnAdded){
        /* r59: المرسل الموحّد — إعادة فحص خفيفة مجمّعة بالإطار */
        window.hzOnAdded(function(){ 
          if (queued) return;
          queued = true;
          (window.requestAnimationFrame || setTimeout)(scanAll);
        });
      } else {
        new MutationObserver(function(){
          if (queued) return;
          queued = true;
          (window.requestAnimationFrame || setTimeout)(scanAll);
        }).observe(document.documentElement, { childList:true, subtree:true });
      }
    }catch(e){}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ===== ١٠) r60 — الدروارات تفتح دائماً من أعلى القائمة =====
   أندرويد يحفظ موضع تمرير الدرج بين فتحة وأخرى (لقطة سهيل: القائمة فاتحة
   مقصوصة من فوق — كانت سكرولة من زيارة سابقة). عند كل فتح نصفّر تمرير
   جسم الدرج ونطفي أي فوكس تلقائي على حقول الإدخال (يمنع قفزة الكيبورد).
   حدث toggle لا يفقع (bubble) لكنه يلتقط نزولاً — نستمع بالتقاط. */
(function(){
  "use strict";
  if (window.__hzDrawerTopInit) return;              /* idempotent */
  window.__hzDrawerTopInit = true;

  function onToggle(e){
    try{
      var d = e.target;
      if (!d || d.tagName !== "DIALOG") return;
      if (e.newState && e.newState !== "open") return;
      if (!d.classList.contains("hdt-dialog-drawer")) return;
      /* r61: السكرولر الفعلي يختلف حسب مقاس الشاشة — نصفّر الديالوج نفسه
         وأي عنصر متسكرل فعلاً بداخله (رخيص: فقط من عنده scrollTop قيمة) */
      d.scrollTop = 0;
      var els = d.querySelectorAll("div, nav, ul");
      for (var i = 0; i < els.length; i++){ if (els[i].scrollTop) els[i].scrollTop = 0; }
      var f = d.querySelector("input:focus, textarea:focus");
      if (f) f.blur();
    }catch(err){}
  }

  document.addEventListener("toggle", onToggle, true);
})();


/* ===== §١١ r64: تعريب نافذة حساب Shopify (shopify-account shadow DOM) =====
   المكوّن Shopify يقدّم نافذة الدخول بالإنجليزية (حد منصة: لغة الحسابات الجديدة
   تتبع اللغة الأساسية الداخلية). الـshadow root مفتوح → نترجم نصوصاً معروفة
   بالضبط (قاموس مغلق) ونعكس سهم الإرسال لليسار RTL. مراقبون مخصّصون لكل
   shadow root فقط (هادئون — يشتغلون عند فتح/إعادة رسم النافذة). */
(function(){
  "use strict";
  if (window.__hzAccountAr) return;
  window.__hzAccountAr = true;

  var MAP = {
    'Sign in or create account': 'سجّلي الدخول أو أنشئي حساباً',
    'Email': 'البريد الإلكتروني',
    'Sign in': 'تسجيل الدخول',
    'Account': 'الحساب',
    'Close menu': 'إغلاق القائمة',
    'Loading sign-in form': 'جارٍ تحميل نموذج الدخول',
    'Sign in with email': 'تسجيل الدخول بالبريد الإلكتروني',
    'Quick links': 'روابط سريعة',
    'Continue': 'متابعة'
  };
  var CSS = 'h2.account__heading{direction:rtl;text-align:right}' +
    'label.login-form__email-label{direction:rtl;text-align:right}' +
    'input.login-form__email-input::placeholder{direction:rtl;text-align:right}' +
    '.login-form__email-submit{right:auto!important;left:10px!important}' +
    '.login-form__email-submit svg{transform:scaleX(-1)}' +
    'input.login-form__email-input{padding-left:52px!important;padding-right:16px!important}' +
    /* r64: توحيد زجاج النوافذ — لوحة نافذة الحساب على وصفة درج السلة */
    'input.login-form__email-input{background-color:rgba(17,17,17,.04)!important;border:1px solid rgba(17,17,17,.16)!important}' +
    'nav a.button.outline{background-color:rgba(17,17,17,.04)!important;border:1px solid rgba(17,17,17,.16)!important}' +
    '.login-form__marketing-consent-visual{background-color:rgba(17,17,17,.04)!important;border:1px solid rgba(17,17,17,.35)!important}' +
    'dialog.dialog::backdrop{background:rgba(17,17,17,.34)!important;-webkit-backdrop-filter:blur(3px)!important;backdrop-filter:blur(3px)!important}' +
    'dialog.dialog{background-color:rgba(255,255,255,.8)!important;background-image:linear-gradient(rgba(255,255,255,.2),rgba(255,255,255,.06))!important;-webkit-backdrop-filter:blur(24px) saturate(1.6)!important;backdrop-filter:blur(24px) saturate(1.6)!important;border-radius:20px!important;box-shadow:0 22px 48px -18px rgba(17,17,17,.4),0 8px 20px -8px rgba(17,17,17,.2),0 2px 8px rgba(17,17,17,.12)!important;border:0!important}';

  var seenRoots = [];

  function patchEl(el){
    try {
      if (el.children && el.children.length === 0){
        var t = (el.textContent || '').trim();
        if (MAP[t]) el.textContent = MAP[t];
      }
      if (el.placeholder && MAP[(el.placeholder || '').trim()]) el.placeholder = MAP[el.placeholder.trim()];
      if (el.getAttribute){
        var al = el.getAttribute('aria-label');
        if (al && MAP[al.trim()]) el.setAttribute('aria-label', MAP[al.trim()]);
      }
    } catch(e){}
  }

  function ensureStyle(root){
    try {
      if (!root.querySelector || root.querySelector('style[data-hz-ar]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-hz-ar', '1');
      st.textContent = CSS;
      root.appendChild(st);
    } catch(e){}
  }

  function patchRoot(root, depth){
    if (!root || depth > 6) return;
    ensureStyle(root);
    var els;
    try { els = root.querySelectorAll('*'); } catch(e){ return; }
    for (var i = 0; i < els.length; i++){
      patchEl(els[i]);
      if (els[i].shadowRoot){ patchRoot(els[i].shadowRoot, depth + 1); observeRoot(els[i].shadowRoot); }
    }
  }

  function observeRoot(root){
    if (seenRoots.indexOf(root) > -1) return;
    seenRoots.push(root);
    try {
      new MutationObserver(function(){ patchRoot(root, 0); syncOverlay(); })
        .observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['open'] });
    } catch(e){}
  }

  /* r67: تعتيم + بلور خلف نافذة الحساب — popover غير modal فلا ::backdrop لها؛
     طبقة ثابتة تحت الهيدر (z:19 < هيدر z:20) وpointer-events:none حتى لا يكسر إغلاقها بالنقر خارجها */
  /* r68: ترقية نافذة الحساب إلى الطبقة العليا (showModal) بدل طبقة يدوية —
     فتأخذ ::backdrop معتم+بلور يغطي الصفحة كلها بما فيها الهيدر والشريط الأسود
     (النافذة non-modal افتراضياً وتعيش داخل سياق تكديس الهيدر z:20). نثبت موقعها
     الأصلي بإحداثيات fixed قبل الترقية، ونغلق بنقرة الخلفية (target=dialog خارج حدوده). */
  function syncOverlay(){
    try {
      var dlgs = [];
      var accs = document.querySelectorAll('shopify-account');
      for (var a = 0; a < accs.length; a++){
        (function chk(root, depth){
          if (!root || depth > 6) return;
          var dl = root.querySelector && root.querySelector('dialog.dialog');
          if (dl && dlgs.indexOf(dl) < 0) dlgs.push(dl);
          var els = root.querySelectorAll('*');
          for (var i = 0; i < els.length; i++){ if (els[i].shadowRoot) chk(els[i].shadowRoot, depth + 1); }
        })(accs[a].shadowRoot, 0);
      }
      dlgs.forEach(function(dlg){
        if (!dlg.__hzWired){
          dlg.__hzWired = true;
          dlg.addEventListener('click', function(ev){
            var b = dlg.getBoundingClientRect();
            if (ev.clientX < b.left || ev.clientX > b.right || ev.clientY < b.top || ev.clientY > b.bottom){ try { dlg.close(); } catch(e){} }
          });
          dlg.addEventListener('close', function(){
            dlg.style.position = ''; dlg.style.top = ''; dlg.style.left = ''; dlg.style.margin = '';
          });
        }
        var isModal = false;
        try { isModal = dlg.matches(':modal'); } catch(e){}
        if (dlg.open && !isModal){
          var r = dlg.getBoundingClientRect();
          try { dlg.close(); } catch(e){}
          dlg.style.position = 'fixed';
          dlg.style.top = Math.max(8, r.top) + 'px';
          dlg.style.left = Math.max(8, r.left) + 'px';
          dlg.style.margin = '0';
          try { dlg.showModal(); } catch(e){ try { dlg.show(); } catch(e2){} }
        }
      });
      var ov = document.getElementById('hz-acc-overlay');
      if (ov) ov.remove();
    } catch(e){}
  }

  function patchAll(){
    var accs = document.querySelectorAll('shopify-account');
    for (var i = 0; i < accs.length; i++){
      if (accs[i].shadowRoot){ patchRoot(accs[i].shadowRoot, 0); observeRoot(accs[i].shadowRoot); }
    }
    syncOverlay();
  }

  /* الـshadow يلتصق بعد ترقية المكوّن غير المتزامنة → محاولات متباعدة بدل مراقب دائم */
  var tries = 0;
  (function retry(){
    patchAll();
    if (++tries < 10) setTimeout(retry, 400 * tries);
  })();
  /* وعند أي نقرة على مكوّن الحساب أعد التطبيق فوراً (فتح النافذة) */
  document.addEventListener('click', function(e){
    try { if (e.target && e.target.closest && e.target.closest('shopify-account, shopify-account-wrapp')) setTimeout(patchAll, 60); } catch(err){}
  }, true);
})();

/* ===== §١٣ r70: درع دوائر الألوان — ترميم ذاتي =====
   شكوى سهيل: دائرة اللون تتحول للأبيض عند ظهور التولتيب وتبقى. الألوان تأتي من
   title=".." (قواعد CSS) أو style مضمّن (conic-gradient للثنائية) — كلاهما عرضة
   للمسح من منطق التولتيب/المعاينة في الثيم. نحفظ نسخة ونرمم فور أي فقدان. */
(function(){
  "use strict";
  if (window.__hzSwatchGuard) return;
  window.__hzSwatchGuard = true;
  function arm(s){
    if (s.__hzArmed) return; s.__hzArmed = true;
    var t = s.getAttribute("title");
    var st = s.getAttribute("style") || "";
    if (t) s.setAttribute("data-hz-title", t);
    if (st.indexOf("gradient") > -1) s.setAttribute("data-hz-grad", st);
    var busy = false;
    try {
      new MutationObserver(function(){
        if (busy) return; busy = true;
        try {
          var keepT = s.getAttribute("data-hz-title");
          if (keepT && !s.getAttribute("title")) s.setAttribute("title", keepT);
          var keepG = s.getAttribute("data-hz-grad");
          var cur = s.getAttribute("style") || "";
          if (keepG && cur.indexOf("gradient") < 0) s.setAttribute("style", keepG);
        } catch(e){}
        busy = false;
      }).observe(s, { attributes: true, attributeFilter: ["title", "style"] });
    } catch(e){}
  }
  function armAll(root){
    (root || document).querySelectorAll("hdt-swatch-card, .hdt-swatch-item").forEach(arm);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function(){ armAll(); }, { once: true });
  else armAll();
  try { window.hzOnAdded(function(){ armAll(); }); } catch(e){
    document.addEventListener("mouseover", function(ev){ try { if (ev.target && ev.target.matches && ev.target.matches("hdt-swatch-card, .hdt-swatch-item")) arm(ev.target); } catch(e2){} }, true);
  }
})();

/* ===== §١٥ r73 — شريط الشحن المجاني: انزلاق التعبئة من القيمة السابقة للجديدة =====
   الشريط (snippets/hz-free-shipping-bar) Liquid صرف، وثيم The4 بيعيد رسم <cart-items-component>
   (الدرج) و[ref="hdt-cart"] (صفحة السلة) بـinnerHTML مع كل إضافة/تغيير/حذف — يعني عنصر التعبئة
   بينخلق من جديد بعرضه النهائي مباشرة وبلا حركة (ومع keyframe كان بيرجع للصفر كل مرّة = رفّة).
   هون بنحفظ آخر نسبة لكل موضع (درج/صفحة)، وعند ظهور نسخة جديدة بنبدأها من النسبة السابقة
   ثم بننقلها للجديدة فيشتغل transition الـCSS (§٥٣). أول ظهور بيبدأ من الصفر (مدخل ناعم).
   لو فشل الـJS لأي سبب: العرض النهائي مرسوم بالـLiquid أصلًا — تحسين تدريجي بحت. */
(function(){
  "use strict";
  if (window.__hzFsbGlide) return;                  /* idempotent */
  window.__hzFsbGlide = true;

  var last = {};                                    /* 'drawer' | 'page' → آخر نسبة */

  function glide(el){
    try{
      if (el.__hzGlided) return;
      el.__hzGlided = true;
      var fill = el.querySelector(".hz-fsb__fill");
      if (!fill) return;
      var key  = el.closest("#CartDrawer") ? "drawer" : "page";
      var to   = parseFloat(fill.style.width) || 0;
      var from = (key in last) ? last[key] : 0;
      last[key] = to;
      if (from === to) return;
      fill.style.transition = "none";
      fill.style.width = from + "%";
      void fill.offsetWidth;                        /* reflow حتى يُثبَّت العرض القديم */
      fill.style.transition = "";
      fill.style.width = to + "%";
    }catch(e){}
  }

  function scan(root){
    try{
      var scope = (root && root.querySelectorAll) ? root : document;
      var els = scope.querySelectorAll(".hz-fsb");
      for (var i = 0; i < els.length; i++) glide(els[i]);
      if (root && root.matches && root.matches(".hz-fsb")) glide(root);
    }catch(e){}
  }

  function start(){
    scan(document);
    try{
      /* r59: المرسل الموحّد — بيمرّر العقدة المضافة (محتوى الدرج/الصفحة بعد إعادة الرسم) */
      if (window.hzOnAdded){
        window.hzOnAdded(scan);
      } else if ("MutationObserver" in window){
        new MutationObserver(function(muts){
          for (var i = 0; i < muts.length; i++)
            for (var j = 0; j < muts[i].addedNodes.length; j++){
              var nd = muts[i].addedNodes[j];
              if (nd.nodeType === 1) scan(nd);
            }
        }).observe(document.documentElement, { childList:true, subtree:true });
      }
    }catch(e){}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
